import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhotoFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M9.1 11.22c-.32-.38-.73-.58-1.17-.57-.45.02-.86.27-1.17.71l-4.32 6.27c.38 1.23 1.51 2.13 2.86 2.13h10.94L9.1 11.21v.01Z" />
      <Path d="M18.67 4.24H5.3c-1.65 0-3 1.35-3 3v8.31l3.39-4.92c.53-.77 1.32-1.23 2.18-1.27.83-.05 1.65.34 2.23 1.03l3.09 3.7 2.19-2.11c.44-.43 1.06-.65 1.67-.62.62.03 1.21.32 1.6.8l3.03 3.64V7.24c0-1.65-1.35-3-3-3h-.01Zm-1.06 4.97c-.67 0-1.21-.54-1.21-1.21 0-.67.54-1.21 1.21-1.21.67 0 1.21.54 1.21 1.21 0 .67-.54 1.21-1.21 1.21Z" />
      <Path d="M16.97 12.64c-.22 0-.43.07-.6.23l-2.32 2.24 3.88 4.65h.74c1.32 0 2.43-.87 2.83-2.06l-3.95-4.76a.81.81 0 0 0-.58-.3Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhotoFilled
